<template>
  <content-dialog
    v-model="dialogOpen"
    title="Insert Table"
    @hide="close"
  >
    <q-list>
      <q-item-wrapper>
        <q-input
          v-model="details.rows"
          label="Rows"
          hint="Number of rows to render on the table"
          outlined
          dense
          type="number"
          :min="1"
        />
      </q-item-wrapper>
      <q-item-wrapper>
        <q-input
          v-model="details.columns"
          label="Columns"
          hint="Number of columns to render on the table"
          outlined
          dense
          type="number"
          :min="1"
        />
      </q-item-wrapper>
      <q-item-wrapper>
        <q-select
          v-model="details.separator"
          label="Borders"
          emit-value
          map-options
          dense
          outlined
          :options="separatorOptions"
        />
      </q-item-wrapper>
    </q-list>

    <template #bottom>
      <q-toolbar>
        <q-space />
        <q-btn
          :disable="details.rows < 1 || details.columns < 1"
          label="Insert"
          color="blue"
          icon-right="mdi-arrow-right"
          @click="generateTableHtml"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
function defaultDetails () {
  return {
    rows: 3,
    columns: 3,
    separator: 'q-table--horizontal-separator'
  }
}

export default {
  emits: ['insert'],
  data () {
    return {
      dialogOpen: false,
      details: defaultDetails(),
      separatorOptions: [
        { label: 'No Borders', value: '' },
        { label: 'Horizontal Borders', value: 'q-table--horizontal-separator' },
        { label: 'Vertical Borders', value: 'q-table--vertical-separator' },
        { label: 'Border between Cells', value: 'q-table--cell-separator' }
      ]
    }
  },
  methods: {
    open () {
      this.dialogOpen = true
    },
    close () {
      this.details = defaultDetails()
      this.dialogOpen = false
    },
    generateTableHtml () {
      let str = `<table class="q-table ${this.details.separator}"><tbody>`
      for (let row = 0; row < this.details.rows; row++) {
        str += '<tr>'
        for (let col = 0; col < this.details.columns; col++) {
          str += '<td></td>'
        }
        str += '</tr>'
      }
      str += '</tbody></table>'
      this.$emit('insert', str)
      this.close()
    }
  }
}
</script>
